import { useGetQcTaskSubmissionMetadata } from '@features/qc_task_details_view/hooks/useGetQCTaskSubmissionQueries'
import { useParams } from 'react-router-dom'
import { Paper, Stack, Typography, Button } from '@mui/material'
import { useState } from 'react'
import FormRendererDialog from '@features/subject/components/FormRendererDialog'
import { DescriptionOutlined } from '@mui/icons-material'
import { SPACING } from '@common/theme/spacing'

export default function PreviousQCForm() {
  const { studyId, qcTaskId } = useParams()
  const [open, setOpen] = useState(false)

  const { data, isLoading, error } = useGetQcTaskSubmissionMetadata({
    study_id: studyId!,
    qc_task_id: qcTaskId!,
    is_previous_qc_task: true,
  })

  if (isLoading || error || !data || !data.qc_task_form_definition || !data.submitted_form) {
    return null
  }

  return (
    <Paper
      sx={{
        padding: SPACING.spacingXl,
        borderRadius: SPACING.borderRadiusXxl,
      }}
    >
      <Stack spacing={SPACING.spacingXxl} width="100%">
        <Typography variant="h6">{`${data.qc_task_form_definition.name.replace('Form', '').trim()} overview`}</Typography>
        <Paper
          sx={{
            padding: SPACING.spacingMd,
            paddingLeft: SPACING.spacingLg,
            borderRadius: SPACING.borderRadiusLg,
            backgroundColor: 'paper.main',
          }}
        >
          <Stack spacing={SPACING.spacingXxl} direction="row" alignItems="center" justifyContent="start" width="100%">
            <Stack
              spacing={SPACING.spacingXs}
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              width="100%"
            >
              <Stack spacing={SPACING.spacingMd} direction="row" alignItems="center">
                <DescriptionOutlined
                  sx={{
                    color: 'text.disabled',
                    fontSize: 20,
                  }}
                />
                <Typography variant="subtitle2">{data.qc_task_form_definition.name}</Typography>
              </Stack>
              <Button
                variant="contained"
                size="small"
                sx={{
                  borderRadius: 2,
                  backgroundColor: 'secondary.main',
                }}
                onClick={() => {
                  setOpen(true)
                }}
              >
                <Typography
                  variant="button"
                  sx={{
                    color: 'secondary.contrastText',
                  }}
                >
                  Open form
                </Typography>
              </Button>
            </Stack>
          </Stack>
        </Paper>
      </Stack>

      {open && (
        <FormRendererDialog
          header="Previous QC Form"
          onClose={() => setOpen(false)}
          fields={JSON.stringify(data.qc_task_form_definition.fields)}
          values={data.submitted_form}
          onSubmit={() => {}}
          readOnly={true}
        />
      )}
    </Paper>
  )
}
